import { Link } from "react-router-dom";
import { TriangleLogo } from "@/components/TriangleLogo";
import { Button } from "@/components/ui/button";
import { usePageTitle } from "@/hooks/usePageTitle";
import { House as Home } from "@phosphor-icons/react";

const NotFound = () => {
  usePageTitle("Página não encontrada");

  return (
    <main className="flex min-h-screen items-center justify-center bg-background bg-glow">
      <div className="text-center space-y-6">
        <TriangleLogo size="xl" animate className="mx-auto opacity-30" />
        <div>
          <h1 className="text-6xl font-bold text-foreground mb-2">404</h1>
          <p className="text-xl text-muted-foreground">Página não encontrada</p>
        </div>
        <p className="text-muted-foreground max-w-md mx-auto">
          A página que você está procurando não existe ou foi movida.
        </p>
        <Button asChild className="gap-2 bg-primary text-background hover:bg-primary/90">
          <Link to="/">
            <Home className="w-4 h-4" />
            Voltar ao Dashboard
          </Link>
        </Button>
      </div>
    </main>
  );
};

export default NotFound;
